const env = process.env.NODE_ENV || 'production';
let routeFront = '';
if (env !== 'dev') {
  routeFront = '/ui/accounts';
}

export const appConstants = {
  PREVIOUS: 'previous',
  NEXT: 'next',
  OBJECT_KEY_ID: 'id',
  ROUTE_LOGIN: '/login',
  ROUTE_MOBILE_DEVICE: '/pairingcodes',
  ROUTE_CLAIM_CODE: '/claimacode',
  ROUTE_BANK_ACCOUNT: '/bankaccounts',
  ROUTE_ORDERS: '/orders',
  ROUTE_OVERVIEW: '/overview',
  ROUTE_AWARD_DETAILS: '/awarddetails',
  ROUTE_ORDER_DETAILS: '/orderdetails',
  ROUTE_ORDER_SEARCH: '/ordersearch',
  COOKIE_access_bearer_token: '_access_bearer_token',
  ROUTE_ACCESS_DENIED: `${routeFront}/accessdenied`,
  ROUTING_PATHS: [`${routeFront}/pairingcodes`,`${routeFront}/`,
    `${routeFront}/bankaccounts`, `${routeFront}/orders`,
    `${routeFront}/overview`,
    `${routeFront}/awarddetails/:orderId`, `${routeFront}/orderdetails/:orderId`],
  FILE_DEFAULT_FORMAT: 'XLSX',
  FIELD_ID: 'fieldId',
  REPORT_ID: 'id',
  GRANT_TYPE_PASSWORD: 'password',
  SEARCH_FIELD_HISTORY: 'SEARCH_FIELD_HISTORY',
  SEARCHED_FIELD_HISTORY_MAX_ITEMS_COUNT: 10,
  TYPE_OF_OBJECT: 'object',
  TYPE_OF_STRING: 'string',
  HTTP_POST: 'post',
  HTTP_PUT: 'put',
  CATEGORY_DEFAULT_OBJECT: {
    categoryDescription: 'This will show all available fields in our system.',
    categoryId: -1,
    categoryName: 'All Fields'
  },
  SORT_BY_DEFAULT: {
    label: 'Sort by..'
  },
  FIELD_DISPLAY_NAME: 'fieldDisplayName',
  TIMEOUT_DELETE_MESSAGE: 3000,
  TIMEOUT_ON_BLUR: 500,
  FILTER_TYPE_INDEX: 'filterTypeIndex',
  SELECTED: 'selected',
  CALENDAR_MONTHS: 1,
  FILEFORMAT_KEYS: {
    TEXT: 'label',
    VALUE: 'value'
  },
  FILTER_KEYS: {
    TEXT: 'displayName',
    VALUE: 'filterId'
  },
  COUNTRIES_KEYS: {
    TEXT: 'text',
    VALUE: 'value'
  },
  FILTER_OPTIONS_TYPE: {
    IS_DATE: 1,
    IS_SINGLE_DROPDOWN: 2,
    IS_MULTI_DROPDOWN: 3
  },
  SORT_BY_KEYS: {
    TEXT: 'displayName',
    VALUE: 'sortId'
  },
  ASC: 'asc',
  DESC: 'desc',
  FILTER_OPTIONS_DROPDOWN_WIDTH: 250,
  MIN_WINDOW_WIDTH: 490,
  ONCLICK_DEFAULT_CODE: 0,
  ONKEYPRESS_ENTER_CODE: 13,
  ONKEYPRESS_ESC_CODE: 27,
  ONKEYPRESS_SPACE_CODE: 32,
  OVERVIEW_RECEIVED_ID: {
    DATE: 'date',
    ACTIVITY_TYPE: 'activity-type',
    RECEIVED_FROM: 'received-from',
    PROGRAM: 'program',
    ACTIONS: 'actions',
    DETAILS: 'details',
    SENDER: 'sender'
  },
  OVERVIEW_SENT_ID: {
    DATE: 'date',
    ACTIVITY_TYPE: 'activity-type',
    GIVEN_TO: 'given-to',
    PROGRAM: 'program',
    STATUS: 'status',
    ACTIONS: 'actions',
    RECEIPIENT: 'recipient',
    DETAILS: 'details',
    SENDER: 'sender'
  },
  OVERVIEW_PERSONAL_INFO_ID: {
    LOGIN_NAME: 'Login Name',
    EMPLOYEE_ID: 'Employee ID',
    CREATED: 'Created'
  },
  BANK_SUMMARY_ID: {
    ACCOUNT_NAME: 'account-name',
    DEPOSITS: 'deposits',
    WITHDRAWALS: 'withdrawals',
    BALANCE: 'balance',
    ACCESS_CODES: 'access_codes',
    ACTIONS: 'actions',
    BANKID: 'bankId'
  },
  RECENT_ORDERS_ID: {
    DATE: 'date',
    ACTIVITY_TYPE: 'activity-type',
    ORDER_ID: 'order-id',
    ORDER_DETAILS: 'view-orders-tracking',
    P42ORDER_ID: 'p42OrderId'
  },
  SKILLS_FINDER: {
    STRENGTH: 'Strength',
    STRENGTH_COUNT: 'Strength Count'
  },
  cacheUrls: ['/api/give/currentTasksCount'],
  POINTS : 'Points',
  ACCESS_CODES: 'AccessCode',
  ACCESS_CODES_NAME: 'Access Code',
  SHARE_ON_FACEBOOK: 'share-on-facebook',
  CATALOG: 'catalog',
  SHARE_ON_TWITTER: 'Share On Twitter',
  VIEW: 'view',
  RESEND: 'resend',
  PRINT_CERTIFICATE:'Print Certificate',
  PRINT_CERTIFICATE_PREVIEW:'print-certificate-preview',
  ACSCODES: 'ACSCODES',
  BANK : 'Bank',
  PROGRAMS_BY_DEFAULT: {
    label: 'All Programs',
    ProgramId: 0
  },
  ORDER_SEARCH: {
    ORDER_NUMBER: 'Order Number',
    RECEIPIENT_NAME: 'Receipient Name',
    PROGRAM: 'Program',
    AWARD_LEVEL: 'Award Level',
    DESCRIPTION: 'Description',
    STATUS: 'Status'
  },
  EXCEL : 'excel',
  PDF : 'pdf',
  XLS : 'xls',
  DOWNLOAD_DATA : ['pdf', 'excel'],
  SUMMARY_REPORT: 'Summary Report',
  ORDER_REPORT: 'Order Report',
  PRINT: 'print',
  DOWNLOAD: 'download',
  EXPIRED: 'expired',
  SERVER_ERROR: 'Server error',
  ROUTE_HISTORY_RECEIVED: '/ui/greatwork/history.html',
  ROUTE_HISTORY_SENT: '/ui/greatwork/history.html#sent',
  ROUTE_DEV: 'https://dev.appreciatehub.com',
  ROUTE_LOGO_HOME : '/ui/greatwork/index.html',
  ROUTE_QA: 'https://qa.appreciatehub.com',
  ROUTE_PROD: 'https://www.appreciatehub.com',
  ROUTE_STAGE: 'https://stage.appreciatehub.com',
  LOGOUT_ENDPOINT: '/logoutRedirect.seam',
  ROUTE_CONTACT_US: '/ui/greatwork/contactus.html',
  ROUTE_RETURN_AWARD: 'https://eclientlink.octanner.com/AwardReturn/index.jsp',
  ROUTE_ORDER_TRACKING_SEARCH: '/ordertracking/OrderSearch.seam',
  ORDER_SEARCH_GO: 'go',
  ORDER_SEARCH_SUBMIT: 'submit',
  ORDER_SEARC_PROGRAM_KEYS:{
    TEXT: 'programNameString',
    VALUE: 'programId'
  },
  TASKSURL: 'tasks.html',
  ERROR_UNAUTHORIZED_ORDERS: 'Not authorized to view order',
  ERROR_UNAUTHORIZED_BANKS: 'Not authorized to view banks',
  NOT_ACCESSED_ERROR_CODE: 403,
  EXPIRED_TOKEN_ERROR_CODE: 401,
  SERVER_TOKEN_ERROR_CODE: 500,
  RECENT_RANGE_KEYS: {
    TEXT: 'text',
    VALUE: 'value'
  },
  RECENT_RANGE_DEFAULT_ONE_MONTH: 3,
  COPYRIGHT_MESSAGE: '2009 O.C. Tanner, all rights reserved.',
  PERMISSION: {
    USER_STRENGTHS: 'USER_STRENGTHS'
  },
  ORDERS: 'Orders',

  // SEGMENT_ACTION_POSITION_TOP: 80,
  // SEGMENT_ACTION_POSITION_LEFT: 470,
  // SEGMENT_ACTION_OFFSET_WIDTH: 200,

  SEGMENT_ACTION_POSITION_TOP: 160,
  SEGMENT_ACTION_POSITION_LEFT: 670,
  SEGMENT_ACTION_OFFSET_WIDTH: 200,
  REWARD: 'reward',
  REWARDTITLE: 'Reward',
  ECARD: 'ecard',
  ECARDTITLE: 'eCard',
  KEY_LANGUAGE: 'language',
  LANGUAGE: 'en-US',
  CACHE_FOR_TRANSLATIONS: {
    MONTHS_SMALL: 'MONTHS_SMALL'
  },
  MONTHS_SMALL: [
    'date-string.months.jan', 'date-string.months.feb', 'date-string.months.mar', 'date-string.months.apr', 'date-string.months.may', 'date-string.months.jun', 'date-string.months.jul', 'date-string.months.aug', 'date-string.months.sep', 'date-string.months.oct', 'date-string.months.nov', 'date-string.months.dec'
  ],
  MONTHS_FULL: [
    'date-string.months.january', 'date-string.months.february', 'date-string.months.march', 'date-string.months.april', 'date-string.months.may', 'date-string.months.june', 'date-string.months.july', 'date-string.months.august', 'date-string.months.september', 'date-string.months.october', 'date-string.months.november', 'date-string.months.december'
  ],
  WEEKS_SMALL: [
    'date-string.weeks.short-sunday', 'date-string.weeks.short-monday', 'date-string.weeks.short-tuesday', 'date-string.weeks.short-wednesday', 'date-string.weeks.short-thursday', 'date-string.weeks.short-friday', 'date-string.weeks.short-saturday'
  ],
  DATE_PICKER_LABELS: { nextMonth: 'date-string.next-month', previousMonth: 'date-string.previous-month' },
  EXPIRED_TOKEN_ERROR:'Missing or expired access token, or invalid user/token',
  DAY_PICKER_ENTER_ACTION: 0,
  OCTANNER_STP: '0001543530',
  CUSTOMER_LABELS: [
    'corporate-value-label', 'ecard-label', 'award-level-label', 'ecards', 'description-of-achievement-label',
    'thank-you-note-label', 'nomination-label', 'submitted'
  ],
  ERROR_TYPE_UNAUTHORIZED: 'error.unauthorized-to-view-order',
  PRINT_CERTIFICATE_TRANS: 'print-certificate',
  NOMINATION: 'nomination',
  RULES: 'rules',
  MANUALLY_ENTERED_DATE: {
    minDateLength: 8,
    minYearLength: 4,
    minDayLength: 2
  },
  INVALID_DATE: 'Invalid Date',
  FROM_DATE: 'fromDate',
  TO_DATE: 'toDate',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  FULL_STORY: {
    legacyPlatform: 'legacy',
    overviewPage: 'accounts_ui_overview_page',
    bankAccounts: 'accounts_ui_bank_accounts_page',
    pairingCodes: 'accounts_ui_pairing_codes_page',
    orders: 'accounts_ui_orders_page',
    orderDetails: 'accounts_ui_orders_details_page',
    awardDetails: 'accounts_ui_award_details_page',
    EVENTS: {
      accountsDetailView: 'Bank Accounts Detail View',
      ordersDetailView: 'View All Orders',
      historyView: 'View All History',
      printBankAccounts: 'Print Bank Account Details',
      downloadBankAccounts: 'Download Bank Account Details',
      printOrders: 'Print Orders Details',
      downloadOrders: 'Download Orders Details',
      viewAwardDetails: 'View Award Details of a Order',
      generatePairingCode: 'Generate Pairing Code',
      viewOrderDetails: 'View Order Details of a Order'
    }
  },
  AFTERSHIP_ORDER_STATUS: {
    IT: 'in-transit',
    AR: 'in-transit',
    I: 'in-transit',
    TRANSIT: 'in-transit',

    OC: 'in-store-pick-up',
    AP: 'in-store-pick-up',
    PRE_TRANSIT: 'in-store-pick-up',
    READY_FOR_PICKUP: 'in-store-pick-up',

    WAITING: 'processing-order',
    W: 'processing-order',
    NA: 'processing-order',
    FAILURE: 'processing-order',
    UNKNOWN: 'processing-order',

    OD: 'delivering',
    O: 'delivering',
    DELIVERING: 'delivering',

    PU: 'picked-up',
    PICKUP_COMPLETE: 'picked-up',

    PX: 'pickup-complete',
    P: 'pickup-complete',

    DL: 'delivered',
    DELIVERED: 'delivered',
    DO: 'delivered',
    DD: 'delivered',
    D: 'delivered',
    DLD: 'delivered',
    DELIVERY_COMPLETED: 'delivered',

    READY: 'info-received',
    M: 'info-received',
    MV: 'info-received',

    SHIPPED: 'shipped',
    CANCELLED: 'cancelled',

    DE: 'delivery-rejected',
    RS: 'delivery-rejected',
    DELIVERY_REJECTED: 'delivery-rejected',

    FAILED: 'failed',
    ORDERED: 'ordered', 
    EMAILED: 'emailed',
    PROCESSING: 'in-process',
    EM: 'emailed'
  },

  ORDER_STATUS: {
    ORDER_CREATED: 'Order Created',
    ORDER_PLACED: 'Order Placed',
    ORDER_PROCESSED: 'Order Processed',
    ORDER_CANCELLED: 'Order Cancelled',
    ORDER_FAILED: 'Order Failed',    
    ORDER_HIDDEN:'Order Hidden',
    PROCESSING_ORDER: 'Processing Order'
  },
  aftershipslug:{
    PB:'Pitney bowes',
    AP:'Australia post',
    CA:'Canada post',
    CE:'Canada post',
    CP:'Canada post',
    US:'Ups',
    FS:'Fedex',
    F1:'Fedex',
    F2:'Fedex',
    F3:'Fedex',
    FG:'Fedex',
    FI:'Fedex',
    DL:'dhl',
    DG:'dhl',
    D1:'dhl',
    ST:'Star track',
    CV:'Ceva',
    CG:'Canpar',
    PG:'Purolator',
    PA:'Purolator',
    PP:'Purolator',
    PU:'Parcel force',
    PS:'usps',
    PT:'Pilot freight',
    FF:'Forwardair',
    SF:'sf express',
    JP:'Japan post',
    RL:'rl carriers',
    TO:'Toll priority',
    NT:'TNT',
    SA:'Sagawa',

    '02': 'Metered mail',
    '098': 'Moogups Worldwide Express',
    '099': 'Micron Ups World Wide Express',
    ABF: 'ABF',
    ABFF: 'ABF Freight',
    AIT: 'AIT Worldwide Logistics',
    ARAMEX:'ARAMEX International Sourcing',
    AT:'ATS',
    AUSTPOST:'Australia Post',
    'AUSTRALIA POST':'Australia Post',
    'AUSTRALIAN POST':'Australia Post',
    STARTRACK:'Startrack',
    AVE: 'Averitt Express',
    BLK: 'ESTES',
    BLUE: 'Blue Dart',
    'BLUE DART': 'Blue Dart',
    BLUEDART: 'Blue Dart',
    'BLUEDART-D': 'Blue Dart',
    BWW: 'WORLD MAIL',
    CEVA: 'CEVA Logistics',
    'CEVA LOGISTICS': 'CEVA Logistics',
    'CEVA WHITE GLOV': 'CEVA Logistics',
    CHRW: 'C.H. ROBINSON',
    CHUN: 'CHUNGWA Post',
    CNM: 'Canpar Multi Piece',
    CNS: 'Canpar',
    CWF: 'Conway Freight',
    D01: 'DHL Worldwide Priority Express',
    D02: 'DHL Inter. Doc. Ser. (Package)',
    D04: 'DHL Express',
    D09: 'DHL Ground',
    DHL: 'DHL',
    DIRE: 'Direct Delivery',
    DLDS: 'Diamond Line Delivery Systems',
    DM1: 'DHL Ecommerce',
    DM2: 'DHL Ecommerce',
    'E-CA': 'Package Manager',
    EFW: 'EFW',
    EGL: 'EGL',
    EMAI: 'EMAIL',
    EMAIL: 'EMAIL',
    'EMAIL DELIVERY': 'EMAIL',
    EMS: 'EMS',
    ENGL  : 'Badger',
    EPOS  : 'Track-Trace',
    ESTA  : 'ESTAFETA',
    ESTE  : 'ESTES',
    EXL  : 'ESTES',
    F01  : 'FEDEX Priority Overnight',
    F02  : 'FEDEX Priority Overnight',
    F03  : 'FEDEX Priority',
    F04  : 'FEDEX Priority',
    F05  : 'FEDEX Priority',
    F06  : 'FEDEX Standard Overnight',
    F07  : 'FEDEX Standard',
    F08  : 'FEDEX Standard',
    F09  : 'FEDEX Standard',
    F10  : 'FEDEX Standard',
    F11  : 'FEDEX 2day',
    F14  : 'FEDEX Express Saver',
    F15  : 'FEDEX 1day Freight',
    F16  : 'FEDEX 2day Freight',
    F17  : 'FEDEX 3day Freight',
    F18  : 'FEDEX Overnight 8:00am',
    F19  : 'FEDEX Overnight',
    F20  : 'FEDEX 2day',
    F21  : 'FEDEX 2day Pak',
    F60  : 'FEDEX INTL First',
    F61  : 'FEDEX INTL First',
    F62  : 'FEDEX INTL First',
    F63  : 'INTL Priority',
    F64  : 'INTL Priority',
    F65  : 'FEDEX International',
    F69  : 'FEDEX Economy',
    F71  : 'FEDEX INTL Priority 10 Kg Box',
    F72  : 'FEDEX INTL Priority 25 Kg Box',
    F73  : 'FEDEX INTL Priority Distributi',
    F74  : 'FEDEX Priority Freight',
    F75  : 'FEDEX Intl Economy Freight',
    FCM  : 'MAIL',
    FDEG  : 'FEDEX Ground',
    FDX  : 'FEDEX Ground',
    FDXH  : 'FEDEX Ground',
    FE  : 'FEDEX Ground',
    FED  : 'FEDEX Ground',
    'FED EX GROUND'  : 'FEDEX Ground',
    FEDE  : 'FEDEX Ground',
    'FEDERAL EXPRESS'  : 'FEDEX Ground',
    FEDEX  : 'FEDEX',
    'FEDEX COLLECT'  : 'FEDEX Ground',
    'FEDEX GROUND'  : 'FEDEX Ground',
    'FEDEX GROUND RE'  : 'FEDEX',
    'FEDEX GROUND SE'  : 'FEDEX',
    'FEDEX MULTISHIP'  : 'FEDEX',
    'FEDEX STANDARD'  : 'FEDEX Ground',
    'FEDX STANDARD'  : 'FEDEX Ground',
    FFO  : 'FEDEX Express First Overnight',
    FILG  : 'Filgifts',
    FIRS  : 'First Flight',
    FL  : 'Old Dominion',
    FM  : 'US Mail Carrier',
    FOR  : 'Forward Air',
    FPO  : 'FEDEX Express First Overnight',
    FPOB  : 'FEDEX Priority Overnight',
    FPOC  : 'FEDEX Prioirty Overnight',
    FPOE  : 'FEDEX Priority Overnight',
    FPOP  : 'FEDEX Prioirty Overnight',
    FPOT  : 'FEDEX Prioirty Overnight',
    FXSP  : 'FEDEX',
    GM  : 'Global Track & Trace',
    GOLD  : 'Golden Cargo',
    HD  : 'Home Direct',
    HOME  : 'Home Direct',
    HUIT  : '17 CKD',
    IPD  : 'FEDEX International Priority',
    LBC  : 'LBC',
    LIAN  : 'LBC',
    NL  : 'Post Nl',
    OCS  : 'Overseas Courier Srvc',
    OCT3  : 'Hold For Pickup',
    OCT4  : 'Hold For Pickup',
    OCT7  : 'Hold For Pickup',
    OCT8  : 'Hold For Pickup',
    OCT9  : 'Hold For Pickup',
    ODF  : 'Old Dominion Freight',
    ODFL  : 'Old Dominion Freight',
    OFI  : 'Fedex International',
    'OLD DOMINION'  : 'Old Dominion Freight',
    'OLD DOMINION FR'  : 'Old Dominion Freight',
    OLDD  : 'Old Dominion Freight',
    P01  : 'Us Mail Carrier',
    P03  : 'Us Mail Carrier',
    P03I  : 'Us Mail Carrier Insured Mail',
    P03R  : 'Us Mail Carrier Registered',
    P04  : 'Fedex Smartpost',
    P05  : 'Fedex Smartpost',
    P08  : 'Us Mail Carrier',
    P09  : 'Us Mail Carrier',
    P2  : 'Purolator 10:30am',
    PE  : 'PAFEX',
    PF  : 'Parcelforce',
    PIL  : 'Pilot',
    PILO  : 'Pilot',
    'PILOT FREIGHTS'  : 'Pilot',
    PL  : 'Pilot',
    PO4  : 'FEDEX Smartpost',
    POSL  : 'POS LAJU',
    PRQT  : 'PRIDE',
    R02  : 'FEDEX',
    R04  : 'FEDEX',
    R13  : 'FEDEX',
    R17  : 'FEDEX',
    R21  : 'FEDEX',
    R25  : 'FEDEX',
    R92  : 'FEDEX',
    R99  : 'FEDEX',
    RDWY  : 'YRC',
    REDDAWAY  : 'REDDAWAY',
    'REGISTERED MAIL'  : 'Us Mail Carrier Registered',
    ROA  : 'Road Runner',
    S1  : 'ST',
    SAG  : 'Sagawa Express',
    SAGA  : 'Sagawa Freight',
    SEIN  : 'SEINO',
    SFEX  : 'Sf Express',
    SNV  : 'Post Nl',
    SPRI  : 'Springfield Ser',
    'STAR TRACK'  : 'Star Track',
    SWFT  : 'Swift',
    TEAM  : 'Team Worldwide',
    TOLL  : 'TOLL',
    'TOLL IPEC'  : 'TOLL',
    U01  : 'UPS Overnight',
    U02  : 'UPS Overnight',
    U07  : 'UPS 2nd Day Air',
    U08  : 'UPS 2nd Day Air',
    U11  : 'UPS Ground',
    U20  : 'UPS Ground',
    U21  : 'UPS 3 Day Select',
    U24  : 'UPS 3 Day Select',
    U25  : 'UPS 2nd Day Air',
    U26  : 'UPS Next Day Air',
    U35  : 'UPS 2nd Day Air A.M.',
    U36  : 'UPS 2nd Day Air A.M.',
    U43  : 'UPS Next Day Air Saver',
    U44  : 'UPS Next Day Air Saver',
    U45  : 'UPS 2nd Day Air A.M',
    U46  : 'UPS Next Day Air',
    U48  : 'UPS Standard To Canada',
    U49  : 'UPS Worldwide Express',
    U54  : 'UPS Worldwide Expedited',
    U60  : 'UPS Next Day Air',
    U61  : 'UPS Next Day Air',
    U63  : 'Ups Worldwide Express',
    U64  : 'Ups Worldwide Express',
    U65  : 'Ups Worldwide Express',
    U66  : 'Ups Worldwide Express',
    U67  : 'Ups Worldwide Express',
    U68  : 'Ups Worldwide Express',
    U69  : 'Ups Worldwide Express',
    U71  : 'Ups Worldwide Saver',
    UEX  : 'Ups Expedited Packages (2 Day)',
    ULP  : 'Ups Expedited Early Am (8:30 Am)',
    UNIT  : 'United Parcel Expedited 5 Day',
    'UNITED PARCEL S'  : 'United Parcel Service',
    UPR  : 'Ups Overnight By 10:30',
    UPS  : 'United Parcel Service',
    'UPS GROUND'  : 'Ups Ground',
    UPSG  : 'Ups Ground',
    UPSN  : 'United Parcel Service',
    USK  : 'Ups Express Saver',
    USM  : 'Ups Standard',
    USMA  : 'Us Mail Carrier',
    USPS  : 'Us Mail Carrier',
    VEND  : 'Vendor Delivery',
    XPO  : 'Xpologistics',
    XX  : 'Hold For Pickup',
    'Y-PA'  : 'Y-PAC',
    YA  : 'International Parcel Services',
    YAMA  : 'International Parcel Services',
    YRC  : 'YRC Freight',
    ZHON  : 'Zhongtong (CHINESE)',
    ZY  : 'Consolidated Shipping Japan',
    ZZ  : 'Consolidated Shipping Europe',
    汇通  : '汇通',
    邮件发送  : 'China Post'
  }
};
